import { Box, DashboardModule, Link } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import { generateRedirectUrl, sortArrayBy } from '@domain-group/javascript-utils'

import useProviderPriceLists from '@hooks/useProviderPriceLists'
import useServices from '@hooks/useServices'
import { generateUrls } from '@hooks/useProviderPriceList'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import type { ServiceModel } from '@models/types'

import ProviderPriceListItem from './ProviderPriceListItem'

const buildPageFilterFields = (filteredServices: ServiceModel[]) => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
    {
      component: 'DynamicInput',
      componentProps: {
        defaultSelectLabel: 'All',
        inputComponent: 'select',
        style,
      },
      key: 'service_id',
      label: 'Service',
      values: sortArrayBy(Object.values(filteredServices), 'asc', 'title').map(service => ({
        key: service.id,
        label: service.title,
      })),
    },
  ]
}

const ProviderPriceLists = (props: {providerId: number}) => {
  const { providerId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const options = {
    filters: { ...pageFilters, provider_id: providerId },
    performHttpRequests: !!providerId,
    requestOptions: {},
  }
  const providerPricesListsPayload = useProviderPriceLists(options)

  const { filteredServices } = useServices({ performHttpRequests: true })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredProviderPriceLists,
    filteredProviderPriceListsCount,
    hasFilteredProviderPriceLists,
    loading,
  } = providerPricesListsPayload

  const { providerPriceListsIndexUrl } = generateUrls()

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-price-lists' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Price Lists"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields(filteredServices)}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredProviderPriceLists && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Price Lists present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              You can create a price list
              <Link href={`${providerPriceListsIndexUrl}?redirect=${generateRedirectUrl()}`}> here</Link>.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredProviderPriceLists && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredProviderPriceLists.map(providerPriceListItem => (
              <ProviderPriceListItem
                key={providerPriceListItem.id}
                providerPriceListItem={providerPriceListItem}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredProviderPriceListsCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}
export default ProviderPriceLists
